import './banner.scss';
import classNames from 'classnames';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Default from './types/Default';
import Video from './types/Video';
import { useTheme } from '..';
const Banner = props => {
  const {
    theme
  } = useTheme();
  const {
    className,
    color,
    compact,
    imagePosition,
    onClick,
    type,
    withShape
  } = props || {};
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-banner', color, type, className, theme, {
      'positioned-image': !!imagePosition,
      'with-shape': withShape,
      compact
    }),
    onClick: onClick
  }, type === 'default' && /*#__PURE__*/React.createElement(Default, props), type === 'video' && /*#__PURE__*/React.createElement(Video, props));
};
Banner.defaultProps = {
  type: 'default'
};
Banner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  compact: PropTypes.bool,
  imagePosition: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string
};
export default /*#__PURE__*/memo(Banner);